import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable, DataTableRowEditCompleteParams } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import React from "react";
import { DatasetDataInputTableProps } from "../DatasetDataInputTable";

interface DatasetDataInputTableDatasetsEditorProps {
  currentConfig: DatasetDataInputTableProps;
  setCurrentConfig: (config: DatasetDataInputTableProps) => void;
}

const DatasetDataInputTableDatasetsEditor = ({
  currentConfig,
  setCurrentConfig,
}: DatasetDataInputTableDatasetsEditorProps) => {
  const handleOverriddenTitleEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        value={options.value || ""}
        className="w-full"
        onChange={e => options.editorCallback?.(e.target.value)}
      />
    );
  };

  const handleRowEditComplete = (e: DataTableRowEditCompleteParams) => {
    const { newData, index } = e;
    const datasetsToUpdate = [...currentConfig.datasets];
    datasetsToUpdate[index] = newData;
    setCurrentConfig({ ...currentConfig, datasets: datasetsToUpdate });
  };

  return (
    <DataTable
      value={currentConfig.datasets}
      editMode="row"
      onRowEditComplete={handleRowEditComplete}
    >
      <Column field="identifier" header="Identifier" style={{ width: "45%" }} />
      <Column
        field="overriddenTitle"
        header="Overridden Title"
        style={{ width: "45%" }}
        editor={handleOverriddenTitleEditor}
      />
      <Column rowEditor style={{ width: "10%", textAlign: "end" }} />
    </DataTable>
  );
};

export default DatasetDataInputTableDatasetsEditor;
